import React from "react"
import Animator from "../components/animator"

export function ScrollGallery({ children }) {
  return <section className="scroll-gallery">{children}</section>
}

export function ScrollGalleryStrip({ children, translateX }) {
  return (
    <Animator
      element="ul"
      classes="scroll-gallery__strip"
      translateX={translateX}
    >
      {children}
    </Animator>
  )
}

export function ScrollGalleryMedia({ children, width, classes }) {
  return (
    <li style={{ width: width }} className={classes ? classes : null}>
      {children}
    </li>
  )
}
